export default {
  getCanSize: (state) => state.canSize,
};
